import { useNavigate } from "react-router-dom";
import { WHO_WE_ARE_IMAGE } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";
import Button from "../Common/Button";

export default function MixMastersAbout() {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-white py-6 md:py-10 font-inter">
      <div className="px-4 md:px-8 lg:px-10 ">
        <div className="flex flex-col lg:flex-row gap-10 items-center">
          {/* LEFT IMAGE */}
          <div
            data-aos="fade-right"
            className="rounded-2xl overflow-hidden md:flex-1 w-full"
            style={{
              background: "linear-gradient(135deg, #e040fb22, #c020d011)",
            }}
          >
            <img
              src={getCloudinaryImageUrl(WHO_WE_ARE_IMAGE, { width: 800 })}
              alt="WhoWeAre"
              className="w-full h-[550px] object-cover"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div
            data-aos="fade-left"
            className="flex-1 flex flex-col justify-center"
          >
            {/* Label */}
            <p
              data-aos="fade-up"
              data-aos-delay="100"
              className="text-xs font-semibold tracking-widest uppercase mb-3 text-[#c020d0]"
            >
              [WHO WE ARE]
            </p>

            {/* Heading */}
            <h2
              data-aos="fade-up"
              data-aos-delay="200"
              className=" mb-5 text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading leading-relaxed"
            >
              Mix Masters RMC (India)
              <br />
              Pvt. Ltd
            </h2>

            {/* Description */}
            <p
              data-aos="fade-up"
              data-aos-delay="300"
              className="text-gray-600 text-sm leading-relaxed mb-8 max-w-full text-justify"
            >
              Mix Masters is a new-age ready-mix concrete company built by
              professionals with deep domain experience and a strong execution
              mindset. Founded with the objective of redefining reliability and
              quality in the RMC ecosystem, Mix Masters combines robust
              operational discipline, process-driven manufacturing, and
              customer-centric service delivery.
            </p>

            {/* Mission & Vision */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {/* Mission */}
              <div
                data-aos="fade-up"
                data-aos-delay="400"
                className="rounded-2xl p-5 bg-[#f9f5ff] border border-[#ede9fe]"
              >
                <h3 className="font-bold mb-2 text-headingText">Our Mission</h3>
                <p className="text-gray-500 text-xs leading-relaxed">
                  Our goal is to become a leader in the ready-mix concrete
                  industry by providing technologically advanced,
                  environmentally friendly, and customizable solutions that
                  guarantee quality and efficiency for every project.
                </p>
              </div>

              {/* Vision */}
              <div
                data-aos="fade-up"
                data-aos-delay="500"
                className="rounded-2xl p-5 bg-[#f5f5f8] border border-[#e8e8ee]"
              >
                <h3 className="font-bold mb-2 text-headingText">Our Vision</h3>
                <p className="text-gray-500 text-xs leading-relaxed">
                  We aspire to be acknowledged as the most reliable and
                  innovative brand in concrete; dedicated to sustainability and
                  excellence.
                </p>
              </div>
            </div>

            {/* Button */}
            <div
              data-aos="fade-up"
              data-aos-delay="600"
              className="flex justify-start"
            >
              <Button onClick={() => navigate(`/about`)} text="Read More" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
